module.exports = __webpack_public_path__ + "media/components/src/assets/images/blogs/9-7d828f48c32336328a0036fe45069d00.jpg";